import { Injectable } from '@angular/core';
import { SessionService } from '../auth/session.service';
import { UserProfile } from '../../models/user';
import * as moment from 'moment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ItemActiveModel } from '../../models/view-model/item-acive-model';
import { SelfAssessmentTemplate3Service } from '../self-assessment-template3/self-assessment-template3.service';
import { rightsManagementSAT3Dto } from '../../models/self-assessmentT3/SelfAssessmentT3Filter';
import { userDropdownDto } from '../../models/self-assessmentT3/SelfAssessmentInterpretation';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  constructor(
    private _sessionService: SessionService,
    private _selfAssessment3Service: SelfAssessmentTemplate3Service
  ) { }
  async getLoginUserData() {
    const result = await this._sessionService.getLoginUserInfo().toPromise();
    return result;
  }
  downloadDocument(data: any, fileName: string, extension: string) {
    const a = document.createElement('a'),
      fileURL = URL.createObjectURL(data);
    a.href = fileURL;
    a.download = `${fileName}${extension}`;
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  }
  getSelectedItems(id: number, selectedItems: number[]): boolean {
    const index = (selectedItems as number[]).indexOf(id);
    return index >= 0 ? true : false;
  }
  allSelectedItems(event: any, dataList: any): number[] {
    let selectedItems: number[] = [];
    if (event.target.checked == true) {
      dataList.forEach((item: any) => {
        selectedItems.push(item.id);
      });
    }
    return selectedItems;
  }
  formatDateWithoutTimezone(date: Date): Date {
    const momentDate = moment(date);
    const formattedDate = momentDate.format('YYYY-MM-DDTHH:mm:ss');
    const utcDate = moment.utc(formattedDate);
    return utcDate.toDate();
  }
  private gearSaT3CallSubject = new Subject<any>();
  // Observable to notify when a function should be called
  gearSaT3Call$ = this.gearSaT3CallSubject.asObservable();
  // Method to trigger the function call
  triggerGearSaT3FunctionCall(
    itemWidth: number,
    isHide: boolean,
    filter: string,
    itemActiveModelT3: ItemActiveModel[]
  ) {
    this.gearSaT3CallSubject.next({
      itemWidth: itemWidth,
      isHide: isHide,
      filter: filter,
      itemActiveModelT3: itemActiveModelT3,
    });
  }
  async getUserPermissionList(
    id: number,
    isVersonHistory: boolean,
    user: UserProfile,
    summaryDetailsId: number,
    tableName: string
  ) {
    if (!isVersonHistory) {
      if (user.displayTitle == 'Compliance Enterprise') {
        return new rightsManagementSAT3Dto(true);
      } else {
        const res = await this._selfAssessment3Service
          .getSelfAssessmentT3UserPermission(
            user.fullName,
            summaryDetailsId,
            tableName,
            id
          )
          .toPromise();
        return res;
      }
    } else {
      return new rightsManagementSAT3Dto(false);
    }
  }
  //dropdown rxjs
  selectedSubmitterName: string = '';
  selectedReviewerName: userDropdownDto[] = [];
  selectedApproverName: userDropdownDto[] = [];
  selectedCondApproverName: userDropdownDto[] = [];

  private submitterDropdownSubject = new Subject<any>();
  submitterDropdownVariable$ = this.submitterDropdownSubject.asObservable();
  setsubmitterDropdownVariable(): void {
    this.submitterDropdownSubject.next();
  }
  private reviewerDropdownSubject = new Subject<any>();
  reviewDropdownVariable$ = this.reviewerDropdownSubject.asObservable();
  setReviewDropdownVariable(): void {
    this.reviewerDropdownSubject.next();
  }
  private approverDropdownSubject = new Subject<any>();
  approverDropdownVariable$ = this.approverDropdownSubject.asObservable();
  setAppprovDropdownVariable(): void {
    this.approverDropdownSubject.next();
  }
  //private condApproverDropdownSubject = new Subject<any>();
 // condApproverDropdownVariable$: Observable<any> = this.condApproverDropdownSubject.asObservable();
  // setCondApproveDropdownVariable(): void {
  //   this.condApproverDropdownSubject.next();
  // }
  scrollSmoothToBottom(elementId: string) {
    let element;
    window.setTimeout(() => {
      element = document.getElementById(elementId);
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    }, 0);
  }
}
